import React from "react";
import IconButtonWrapper from "../../../common/form-fields-mui/IconButtonWrapper";
import { ReactComponent as BackIcon } from "assets/img/svg/BackButton.svg";
import CustomChip from "views/pages/manage/common/customChip/CustomChip.jsx";
import { chipContainerStyle } from "../../../common/branchesCommonComponent/EditBranchesBasedOnBusinessArea";
import { ReactComponent as IoEyeOutline } from "assets/img/svg/fi_info.svg";
import { useGetCollectPaymentContext } from "../context";
import MarkEligibleCourseDetailsPopup from "../../../edpOps/stockManagement/dlpStockIssuance/markEligible/MarkEligibleCourseDetailsPopup";
import EPMRDetailsDialog from "../selectPaymentMode/epmrValidation";
import { programActionStyles } from "../../studentCharges/studentList";
export const RenderHeaderChip = ({ label, value, children }) => {
  return (
    <CustomChip
      style={chipContainerStyle}
      className="body-regular global-font-size"
    >
      {label}:<span className="text-bold">{value}</span>
      {children}
    </CustomChip>
  );
};

export const CourseIdComponent = ({ studentBasicDetails }) => (
  <RenderHeaderChip label={"Course ID"} value={studentBasicDetails?.courseId}>
    <span>
      <MarkEligibleCourseDetailsPopup
        Icon={IoEyeOutline}
        applicationData={studentBasicDetails}
        isCollection={true}
      ></MarkEligibleCourseDetailsPopup>
    </span>{" "}
  </RenderHeaderChip>
);

const getHeaderItems = (studentData) => {
  const listItems = [
    {
      label: "BU",
      value: studentData?.bu,
    },
    {
      label: "Cashier office",
      value: studentData?.cashierOffice,
    },
    {
      label: "Name",
      value: studentData?.studentName,
    },
    {
      label: "PSID",
      value: studentData?.psid,
    },
    {
      label: "Application ID",
      value: studentData?.applicationId,
    },
    {
      label: "Term",
      value: studentData?.term,
    },
  ];
  return listItems.filter(item=>item?.value)
};

const TopHeader = ({
  module , 
  backIconClickHandler = () => {window.close()} , 
  getHeaderChips = getHeaderItems
}) => {
  const { studentBasicDetails } = useGetCollectPaymentContext(module);
  const headerChips = getHeaderChips(studentBasicDetails);

  return (
    <div
      className="d-flex heading-4 color-dark align-items-center justify-content-between top-header-collect-payment"
      //   style={headerStyle}
    >
      <EPMRDetailsDialog />
      <div className="d-flex align-items-center">
        <IconButtonWrapper onClick={backIconClickHandler}>
          <BackIcon />
        </IconButtonWrapper>
        <div className="">Payment collection</div>
      </div>
      <div>
        <div className="mr-2 d-flex align-items-center gap-md">
          {headerChips.map((headerItem) => (
            <RenderHeaderChip
              key={headerItem.label}
              label={headerItem.label}
              value={headerItem.value|| "-"}
            />
          ))}
          <CourseIdComponent studentBasicDetails={studentBasicDetails} />
          <span
            style={programActionStyles?.[studentBasicDetails?.programAction]}
          >
            {studentBasicDetails?.programAction}
          </span>
        </div>
      </div>
    </div>
  );
};

export default TopHeader;
